module.exports = __webpack_public_path__ + "img/38.689c208e.png";